import React, {ReactNode} from "react";
import {SvgIcon} from "@mui/material";
import {IconVolumeProps} from "./IconVolume.types";


abstract class IconVolume extends React.Component<IconVolumeProps>   {


    public render(): ReactNode   {
        return (
            <SvgIcon key={"icon-" + this.props.key} style={this.props.style}>
                {this.renderDraw(this.props)}
            </SvgIcon>
        );
    }


    private renderDraw(props: IconVolumeProps): ReactNode   {
        if (this.props.muted)   {
            return (
                <g>
                    <rect fill="none" height="24" width="24"/>
                    <path d="M4.34 2.93L2.93 4.34 7.29 8.7 7 9H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06c1.34-.3 2.57-.92 3.61-1.75l2.05 2.05 1.41-1.41L4.34 2.93zM10 15.17L7.83 13H5v-2h2.83l.88-.88L10 11.41v3.76zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-7-8l-1.88 1.88L12 7.76zm4.5 8c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"/>
                </g>
            );
        }
        if (this.props.volume > 85) {
            return (
                <g>
                    <rect fill="none" height="24" width="24"/>
                    <path d="M 16.5,12 C 16.5,10.23 15.48,8.71 14,7.97 v 8.05 C 15.48,15.29 16.5,13.77 16.5,12 Z M 14,3.23 v 2.06 c 2.89,0.86 5,3.54 5,6.71 0,3.17 -2.11,5.85 -5,6.71 v 2.06 C 18.01,19.86 21,16.28 21,12 21,7.72 18.01,4.14 14,3.23 Z"/>
                    <path d="m 3,9 v 6 h 4 l 5,5 V 4 L 7,9 Z m 7,-0.17 v 6.34 L 7.83,13 H 5 v -2 h 2.83 z"/>
                </g>
            );
        }
        if (this.props.volume > 70) {
            return (
                <g>
                    <rect fill="none" height="24" width="24"/>
                    <path d="m 3,9 v 6 h 4 l 5,5 V 4 L 7,9 Z m 7,-0.17 v 6.34 L 7.83,13 H 5 v -2 h 2.83 z"/>
                    <path d="M 15.908343,11.999999 C 15.908343,10.648893 15.129739,9.4886205 14,8.9237511 v 6.1448629 c 1.129739,-0.557236 1.908343,-1.717508 1.908343,-3.068615 z M 14,5.3055336 v 1.5724743 c 2.206044,0.6564699 3.816686,2.7022131 3.816686,5.1219911 0,2.419779 -1.610642,4.465522 -3.816686,5.121992 v 1.572474 c 3.060982,-0.694636 5.34336,-3.427383 5.34336,-6.694466 0,-3.2670822 -2.282378,-5.9998287 -5.34336,-6.6944654 z"/>
                </g>
            );
        }
        if (this.props.volume > 55) {
            return (
                <g>
                    <rect fill="none" height="24" width="24"/>
                    <path d="M 15.471574,12 C 15.471574,10.958126 14.871171,10.063409 14,9.6278231 V 14.366291 C 14.871171,13.936591 15.471574,13.041874 15.471574,12 Z M 14,6.8377194 V 8.0502962 C 15.701139,8.5565175 16.943147,10.134045 16.943147,12 c 0,1.865955 -1.242008,3.443482 -2.943147,3.949704 v 1.212577 C 16.360404,16.626628 18.120406,14.519334 18.120406,12 18.120406,9.4806658 16.360404,7.3733722 14,6.8377194 Z"/>
                    <path d="m 3,9 v 6 h 4 l 5,5 V 4 L 7,9 Z m 7,-0.17 v 6.34 L 7.83,13 H 5 v -2 h 2.83 z"/>
                </g>
            );
        }
        if (this.props.volume > 40) {
            return (
                <g>
                    <rect fill="none" height="24" width="24"/>
                    <path d="m 3,9 v 6 h 4 l 5,5 V 4 L 7,9 Z m 7,-0.17 v 6.34 L 7.83,13 H 5 v -2 h 2.83 z"/>
                    <path d="m 15.124067,11.999999 c 0,-0.795839 -0.458619,-1.479272 -1.124067,-1.811996 v 3.619496 c 0.665448,-0.328227 1.124067,-1.01166 1.124067,-1.8075 z M 14,8.0567712 v 0.9262314 c 1.299422,0.3866792 2.248135,1.5916794 2.248135,3.0169964 0,1.425318 -0.948713,2.630318 -2.248135,3.016998 v 0.92623 c 1.803004,-0.40916 3.147388,-2.018825 3.147388,-3.943228 0,-1.924403 -1.344384,-3.5340674 -3.147388,-3.9432278 z"/>
                </g>
            );
        }
        if (this.props.volume > 25) {
            return (
                <g>
                    <rect fill="none" height="24" width="24"/>
                    <path d="m 14.862915,12 c 0,-0.610943 -0.352069,-1.135596 -0.862915,-1.391019 v 2.778588 C 14.510846,13.135597 14.862915,12.610944 14.862915,12 Z M 14,8.9728931 V 9.6839355 C 14.99753,9.9807781 15.725831,10.905824 15.725831,12 c 0,1.094177 -0.728301,2.019223 -1.725831,2.316065 v 0.711043 C 15.384116,14.713006 16.416163,13.477312 16.416163,12 16.416163,10.522689 15.384116,9.2869943 14,8.9728931 Z"/>
                    <path d="m 3,9 v 6 h 4 l 5,5 V 4 L 7,9 Z m 7,-0.17 v 6.34 L 7.83,13 H 5 v -2 h 2.83 z"/>
                </g>
            );
        }
        if (this.props.volume > 10) {
            return (
                <g>
                    <rect fill="none" height="24" width="24"/>
                    <path d="m 3,9 v 6 h 4 l 5,5 V 4 L 7,9 Z m 7,-0.17 v 6.34 L 7.83,13 H 5 v -2 h 2.83 z"/>
                    <path d="m 15.124067,11.999999 c 0,-0.795839 -0.458619,-1.479272 -1.124067,-1.811996 v 3.619496 c 0.665448,-0.328227 1.124067,-1.01166 1.124067,-1.8075 z"/>
                </g>
            );
        }
        return (
            <g>
                <rect fill="none" height="24" width="24"/>
                <path d="m 3,9 v 6 h 4 l 5,5 V 4 L 7,9 Z m 7,-0.17 v 6.34 L 7.83,13 H 5 v -2 h 2.83 z"/>
            </g>
        );
    }

}


export default IconVolume;
